import CustomLayout from "./wrapPageElement"
/* import "./src/global.css" */

export const wrapPageElement = CustomLayout
